import {
  MEMBERSHIP_MODELS,
  PLAYER_PORTALS_MODELS,
} from '@r-and-a-shared-ui/common-kontent-client';
import { getFirstLinkedAssetOrDefault } from '@r-and-a-shared-ui/common-kontent-client/utils';
import { getFirstMappedLinkedItemOrDefault } from './utils/component-mapping-helpers';

type HeroBannerModel = MEMBERSHIP_MODELS.HeroBanner &
  PLAYER_PORTALS_MODELS.HeroBanner;

const createButton = (entry: MEMBERSHIP_MODELS.HeroBannerButton) => {
  if (!entry || !entry?.elements) {
    return undefined;
  }

  const { elements } = entry || {};

  const linkItem = getFirstMappedLinkedItemOrDefault(elements?.link);

  if (!linkItem) {
    return undefined;
  }

  return {
    link: linkItem,
    ctaText: elements?.text?.value,
  };
};

export const hero_banner = (entry: HeroBannerModel) => {
  if (!entry || !entry?.elements) {
    return undefined;
  }

  const { elements } = entry || {};

  const backgroundImage = getFirstLinkedAssetOrDefault(
    elements?.background_image || elements?.desktop_background_image,
  );

  const mobileBackgroundImage = getFirstLinkedAssetOrDefault(
    elements?.mobile_image || elements?.mobile_background_image,
  );

  const buttons = elements?.buttons?.linkedItems?.map(createButton);

  return {
    title: elements?.title?.value,
    subtitle: elements?.subtitle?.value,
    description: elements?.description?.value,
    backgroundImage: backgroundImage,
    mobileImage: mobileBackgroundImage || backgroundImage,
    buttons: buttons,
  };
};

export default hero_banner;
